<template>
    <div class="webcam-pic">
        <img :src="imageUrl"
            alt="Bild des Lechsees und der umliegenden Bergkette" />
    </div>
</template>

<script>
    import V from 'voUtils/V.js';
    export default {
    	voVueComponent: 'voffice-webcam',

    	data() {
    		return {
    			baseUrl: "https://www.ferienhaeuser-via-claudia.de/webcam72/WebcamVia72.jpg",
    			imageUrl: "",
    			intervalId: null,
    		};
    	},

    	methods: {
    		refreshImage: async function() {
    			try {
    				// 1. Server-Trigger (CORS-sicher)
    				await fetch("https://www.ferienhaeuser-via-claudia.de/webcam72/crop.php", {
    					mode: "no-cors"
    				});

    				// 2. Bild neu laden (Cache umgehen)
    				this.imageUrl = this.baseUrl + "?t=" + Date.now();

    			} catch (e) {
    				console.error("Webcam refresh failed:", e);
    			}
    		},
    	},

    	mounted: function() {
    		// Erstes Laden
    		this.refreshImage();

    		// Alle 60 Sekunden aktualisieren
    		this.intervalId = setInterval(() => {
    			this.refreshImage();
    		}, 360000);
    	},

    	beforeDestroy: function() {
    		// Interval beim Verlassen der Komponente stoppen
    		clearInterval(this.intervalId);
    	},
    };
</script>